import { setCdnContainer } from 'owa-config/lib/defaultCdnSettings';
import { setLayout } from 'owa-config';
setCdnContainer('owamini/');
setLayout('Phone');
